/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTileRunStatus} from '../api'

 export const useQueryGetTileRunStatus = createReactQueryHook('getTileRunStatus', getTileRunStatus)
